import { compact } from '../../../../helpers/compact';
import { FeaturedPostsSlice, HomeSliceType } from '../../../../types/slice';
import { toLink, toText } from '../../fields';
import homeTile from './home-tile';

const featuredPostsSlice = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): FeaturedPostsSlice | undefined => {
  if (data.primary?.enabled !== 'oui') {
    return undefined;
  }

  const title = toText(data.primary?.title);
  if (!title) {
    return undefined;
  }

  return compact({
    type: HomeSliceType.FEATURED_POSTS,
    title,
    subtitle: toText(data.primary?.subTitle),
    ctaLabel: toText(data.primary?.CTALabel),
    ctaLink: toLink(data.primary?.CTALink),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tiles: data.items.map((post: any) => homeTile(post)),
  });
};

export default featuredPostsSlice;
